/**
 * Records the previous in-app URL as `window.__internalReferrer` on every route change, so GTM/analytics
 * (composables/setup-gtm.ts) can report an internal referrer across SPA navigation, where
 * `document.referrer` does not update. Client-only: it reads `window`, and only the browser navigates.
 */
declare global {
  interface Window {
    __internalReferrer?: string
  }
}

export default defineNuxtPlugin(() => {
  const router = useRouter()
  router.afterEach((_to, from, failure) => {
    // A navigation that was aborted, cancelled, duplicated or redirected still reaches `afterEach`.
    // Recording it would make the page the visitor is already on its own referrer.
    if (failure) {
      return
    }

    if (from.name) {
      window.__internalReferrer = window.location.origin + from.fullPath
    }
  })
})
